export default "__VITE_PUBLIC_ASSET__44aa1879__"